import App from './containers/App/App';
import Login from './containers/Login/Login';
import Dashboard from './containers/Dashboard/Dashboard';

import Users from './containers/Users/Users';
import UsersList from './containers/Users/UsersList/UsersList';
import UserShow from './containers/Users/UserShow/UserShow';
import UserEdit from './containers/Users/UserEdit/UserEdit';
import UserCreate from './containers/Users/UserCreate/UserCreate';
import UserDelete from './containers/Users/UserDelete/UserDelete';

import Courses from './containers/Courses/Courses';
import CoursesList from './containers/Courses/CoursesList/CoursesList';
import CourseShow from './containers/Courses/CourseShow/CourseShow';
import CourseEdit from './containers/Courses/CourseEdit/CourseEdit';
import CourseCreate from './containers/Courses/CourseCreate/CourseCreate';
import CourseDelete from './containers/Courses/CourseDelete/CourseDelete';

import Groups from './containers/Groups/Groups';
import GroupsList from './containers/Groups/GroupsList/GroupsList';
import GroupShow from './containers/Groups/GroupShow/GroupShow';
import GroupEdit from './containers/Groups/GroupEdit/GroupEdit';
import GroupCreate from './containers/Groups/GroupCreate/GroupCreate';
import GroupDelete from './containers/Groups/GroupDelete/GroupDelete';

import Holidays from './containers/Holidays/Holidays';
import HolidaysList from './containers/Holidays/HolidaysList/HolidaysList';
import HolidayShow from './containers/Holidays/HolidayShow/HolidayShow';
import HolidayEdit from './containers/Holidays/HolidayEdit/HolidayEdit';
import HolidayCreate from './containers/Holidays/HolidayCreate/HolidayCreate';
import HolidayDelete from './containers/Holidays/HolidayDelete/HolidayDelete';

import Students from './containers/Students/Students';
import StudentsList from './containers/Students/StudentsList/StudentsList';
import StudentShow from './containers/Students/StudentShow/StudentShow';
import StudentEdit from './containers/Students/StudentEdit/StudentEdit';
import StudentCreate from './containers/Students/StudentCreate/StudentCreate';
import StudentDelete from './containers/Students/StudentDelete/StudentDelete';

import Subjects from './containers/Subjects/Subjects';
import SubjectsList from './containers/Subjects/SubjectsList/SubjectsList';
import SubjectShow from './containers/Subjects/SubjectShow/SubjectShow';
import SubjectEdit from './containers/Subjects/SubjectEdit/SubjectEdit';
import SubjectCreate from './containers/Subjects/SubjectCreate/SubjectCreate';
import SubjectDelete from './containers/Subjects/SubjectDelete/SubjectDelete';

import Teachers from './containers/Teachers/Teachers';
import TeachersList from './containers/Teachers/TeachersList/TeachersList';
import TeacherShow from './containers/Teachers/TeacherShow/TeacherShow';
import TeacherEdit from './containers/Teachers/TeacherEdit/TeacherEdit';
import TeacherCreate from './containers/Teachers/TeacherCreate/TeacherCreate';
import TeacherDelete from './containers/Teachers/TeacherDelete/TeacherDelete';

import Invoices from './containers/Invoices/Invoices';
import InvoicesList from './containers/Invoices/InvoicesList/InvoicesList';
import InvoiceShow from './containers/Invoices/InvoiceShow/InvoiceShow';
import InvoiceEdit from './containers/Invoices/InvoiceEdit/InvoiceEdit';
import InvoiceCreate from './containers/Invoices/InvoiceCreate/InvoiceCreate';
import InvoiceDelete from './containers/Invoices/InvoiceDelete/InvoiceDelete';

import CoursesPlanning from './containers/Planning/CoursesPlanning/CoursesPlanning';

import Members from './containers/Members/Members';
import MembersList from './containers/Members/MembersList/MembersList';
import MemberShow from './containers/Members/MemberShow/MemberShow';
import MemberEdit from './containers/Members/MemberEdit/MemberEdit';
import MemberCreate from './containers/Members/MemberCreate/MemberCreate';
import MemberDelete from './containers/Members/MemberDelete/MemberDelete';

const routes = [
    {
        path: "login",
        element: <Login />,
    },
    {
        path: "/",
        element: <App />,
        children: [
            {
                path: "",
                element: <Dashboard />,
            },
            {
                path: "users",
                element: <Users />,
                children: [
                    { path: "list", element: <UsersList /> },
                    { path: "new", element: <UserCreate /> },
                    { path: "show/:userId", element: <UserShow /> },
                    { path: "edit/:userId", element: <UserEdit /> },
                    { path: "delete/:userId", element: <UserDelete /> },
                ]
            },
            {
                path: "groups",
                element: <Groups />,
                children: [
                    { path: "list", element: <GroupsList /> },
                    { path: "new", element: <GroupCreate /> },
                    { path: "show/:groupId", element: <GroupShow /> },
                    { path: "edit/:groupId", element: <GroupEdit /> },
                    { path: "delete/:groupId", element: <GroupDelete /> },
                ]
            },
            {
                path: "holidays",
                element: <Holidays />,
                children: [
                    { path: "list", element: <HolidaysList /> },
                    { path: "new", element: <HolidayCreate /> },
                    { path: "show/:holidayId", element: <HolidayShow /> },
                    { path: "edit/:holidayId", element: <HolidayEdit /> },
                    { path: "delete/:holidayId", element: <HolidayDelete /> },
                ]
            },
            {
                path: "planning",
                element: <CoursesPlanning />,
                children: [
                    { path: "courses", element: <CoursesPlanning /> },
                ]
            },
            {
                path: "courses",
                element: <Courses />,
                children: [
                    { path: "list", element: <CoursesList /> },
                    { path: "new/from/:userId", element: <CourseCreate /> },
                    { path: "new", element: <CourseCreate /> },
                    { path: "show/:courseId", element: <CourseShow /> },
                    { path: "edit/:courseId", element: <CourseEdit /> },
                    { path: "delete/:courseId", element: <CourseDelete /> },
                ]
            },
            {
                path: "students",
                element: <Students />,
                children: [
                    { path: "list", element: <StudentsList /> },
                    { path: "new/from/:userId", element: <StudentCreate /> },
                    { path: "new", element: <StudentCreate /> },
                    { path: "show/:studentId", element: <StudentShow /> },
                    { path: "edit/:studentId", element: <StudentEdit /> },
                    { path: "delete/:studentId", element: <StudentDelete /> },
                ]
            },
            {
                path: "subjects",
                element: <Subjects />,
                children: [
                    { path: "list", element: <SubjectsList /> },
                    { path: "new", element: <SubjectCreate /> },
                    { path: "show/:subjectId", element: <SubjectShow /> },
                    { path: "edit/:subjectId", element: <SubjectEdit /> },
                    { path: "delete/:subjectId", element: <SubjectDelete /> },
                ]
            },
            {
                path: "teachers",
                element: <Teachers />,
                children: [
                    { path: "list", element: <TeachersList /> },
                    { path: "new", element: <TeacherCreate /> },
                    { path: "show/:teacherId", element: <TeacherShow /> },
                    { path: "edit/:teacherId", element: <TeacherEdit /> },
                    { path: "delete/:teacherId", element: <TeacherDelete /> },
                ]
            },
            {
                path: "invoices",
                element: <Invoices />,
                children: [
                    { path: "list", element: <InvoicesList /> },
                    { path: "new/from/:userId", element: <InvoiceCreate /> },
                    { path: "new", element: <InvoiceCreate /> },
                    { path: "show/:invoiceId", element: <InvoiceShow /> },
                    { path: "edit/:invoiceId", element: <InvoiceEdit /> },
                    { path: "delete/:invoiceId", element: <InvoiceDelete /> },
                ]
            },
            {
                path: "members",
                element: <Members />,
                children: [
                    { path: "list", element: <MembersList /> },
                    { path: "new/from/:userId", element: <MemberCreate /> },
                    { path: "new", element: <MemberCreate /> },
                    { path: "show/:memberId", element: <MemberShow /> },
                    { path: "edit/:memberId", element: <MemberEdit /> },
                    { path: "delete/:memberId", element: <MemberDelete /> },
                ]
            },
        ]
    }
];

export default routes;
